let key = {};
if (process.env.NODE_ENV == "production") {
    key = [
        // {   name                : "Polygon",
        //     chainname           : "Matic Mainnet",
        //     chainsymbol         : "MATIC",
        //     rpcUrls             : "https://polygon-rpc.com",
        //     blockExplorerUrls   : "https://polygonscan.com/",
        //     networkVersion      : 137,
        //     chainid             : 137,
        //     networkdecimal      : 18,
        //     hex_chainid         : 0x137,
        //     bridgecontract      : "0xfd3Fc878e6524e8CfA296dDAA4050Bda9504b1eb",
        //     tokencontract       : "0x31F04B4118590E26ef76Ef81caF0b05EcB41758d"
        // },
        // {
        //     name                : "Binance",
        //     chainname           : "Smart Chain",
        //     chainsymbol         : "BNB",
        //     rpcUrls             : "https://bsc-dataseed.binance.org",
        //     blockExplorerUrls   : "https://bscscan.com",
        //     networkVersion      : 56,
        //     chainid             : 56,
        //     networkdecimal      : 18,
        //     bridgecontract      : "0x1F292E395692Fc731bAd61Bb42fBCD89B0d6FB25",
        //     tokencontract       : "0xa99a18398195cF115eD2FF1D65f230EEA083ec8a"
        // }
        {   name                : "AVAX",
            chainname           : "Avalanche Testnet",
            chainsymbol         : "AVAX",
            rpcUrls             : "https://api.avax-test.network/ext/bc/C/rpc",
            blockExplorerUrls   : "https://testnet.snowtrace.io/",
            networkVersion      : 43113,
            chainid             : 43113,
            networkdecimal      : 18,
            bridgecontract      : "0xfd1ad9029B8Ac85226C8A9c3f4b5c4ac5bacDC76",
            tokencontract       : "0xfd1ad9029B8Ac85226C8A9c3f4b5c4ac5bacDC76",
            image               : "aval.png",
            payable             : 3,
            passchainid         : 10106

        },
        {
            name                : "BNB",
            chainname           : "BINANCE TESTNET",
            chainsymbol         : "BNB",
            rpcUrls             : "https://data-seed-prebsc-1-s1.binance.org:8545/",
            blockExplorerUrls   : "https://testnet.bscscan.com/",
            networkVersion      : 97,
            chainid             : 97,
            networkdecimal      : 18,
            bridgecontract      : "0xCbAe8170D65Ee0260e888F73731211350E98F3Ee",
            tokencontract       : "0x4B601CC049939c1f079Ac348e74B66D409F37C3A",
            image               : "bnb.png",
            payable             : 0.01,
            passchainid         : 10102
        },
        {
            name                : "GoerliETH",
            chainname           : "Goerli test network",
            chainsymbol         : "GoerliETH",
            rpcUrls             : "https://goerli.infura.io/v3/3bcaf6ef4c4e45fb99daf23385e04568",
            blockExplorerUrls   : "https://goerli.etherscan.io/",
            networkVersion      : 5,
            chainid             : 5,
            networkdecimal      : 18,
            bridgecontract      : "0xd9740bd883bDF5157d2DA1a2C939B7DC605a346F",
            tokencontract       : "0xd9740bd883bDF5157d2DA1a2C939B7DC605a346F",
            image               : "goerli.png",
            payable             : 0.01,
            passchainid         : 10121
        },
        {
            name                : "MATIC",
            chainname           : "Matic Mumbai TESTNET",
            chainsymbol         : "MATIC",
            rpcUrls             : "https://polygon-mumbai-bor.publicnode.com/",
            blockExplorerUrls   : "https://mumbai.polygonscan.com/",
            networkVersion      : 80001,
            chainid             : 80001,
            networkdecimal      : 18,
            bridgecontract      : "0x93a38b3A3706500130CDf60900F088F00D855ccc",
            tokencontract       : "0x93a38b3A3706500130CDf60900F088F00D855ccc",
            image               : "mumbai.png",
            payable             : 3,
            passchainid         : 10109
            
        },
        {
            name                : "FTM",
            chainname           : "Fantom Testnet",
            chainsymbol         : "FTM",
            rpcUrls             : "https://rpc.testnet.fantom.network/",
            blockExplorerUrls   : "https://testnet.ftmscan.com/",
            networkVersion      : 4002,
            chainid             : 4002,
            networkdecimal      : 18,
            bridgecontract      : "0x20566d84d979841849478E3d17FC81445152B84b",
            tokencontract       : "0x20566d84d979841849478E3d17FC81445152B84b",
            image               : "fantom.png",
            payable             : 3,
            passchainid         : 10112
            
        },

   ];
} else {
    key = [
        {   name                : "AVAX",
            chainname           : "Avalanche Testnet",
            chainsymbol         : "AVAX",
            rpcUrls             : "https://api.avax-test.network/ext/bc/C/rpc",
            blockExplorerUrls   : "https://testnet.snowtrace.io/",
            networkVersion      : 43113,
            chainid             : 43113,
            networkdecimal      : 18,
            bridgecontract      : "0xfd1ad9029B8Ac85226C8A9c3f4b5c4ac5bacDC76",
            tokencontract       : "0xfd1ad9029B8Ac85226C8A9c3f4b5c4ac5bacDC76",
            image               : "aval.png",
            payable             : 3,
            passchainid         : 10106

        },
        {
            name                : "BNB",
            chainname           : "BINANCE TESTNET",
            chainsymbol         : "BNB",
            rpcUrls             : "https://data-seed-prebsc-1-s1.binance.org:8545/",
            blockExplorerUrls   : "https://testnet.bscscan.com/",
            networkVersion      : 97,
            chainid             : 97,
            networkdecimal      : 18,
            bridgecontract      : "0xCbAe8170D65Ee0260e888F73731211350E98F3Ee",
            tokencontract       : "0x4B601CC049939c1f079Ac348e74B66D409F37C3A",
            image               : "bnb.png",
            payable             : 0.01,
            passchainid         : 10102
        },
        {
            name                : "GoerliETH",
            chainname           : "Goerli test network",
            chainsymbol         : "GoerliETH",
            rpcUrls             : "https://goerli.infura.io/v3/3bcaf6ef4c4e45fb99daf23385e04568",
            blockExplorerUrls   : "https://goerli.etherscan.io/",
            networkVersion      : 5,
            chainid             : 5,
            networkdecimal      : 18,
            bridgecontract      : "0xd9740bd883bDF5157d2DA1a2C939B7DC605a346F",
            tokencontract       : "0xd9740bd883bDF5157d2DA1a2C939B7DC605a346F",
            image               : "goerli.png",
            payable             : 0.01,
            passchainid         : 10121
        },
        {
            name                : "MATIC",
            chainname           : "Matic Mumbai TESTNET",
            chainsymbol         : "MATIC",
            rpcUrls             : "https://polygon-mumbai-bor.publicnode.com/",
            blockExplorerUrls   : "https://mumbai.polygonscan.com/",
            networkVersion      : 80001,
            chainid             : 80001,
            networkdecimal      : 18,
            bridgecontract      : "0x93a38b3A3706500130CDf60900F088F00D855ccc",
            tokencontract       : "0x93a38b3A3706500130CDf60900F088F00D855ccc",
            image               : "mumbai.png",
            payable             : 3,
            passchainid         : 10109
            
        },
        {
            name                : "FTM",
            chainname           : "Fantom Testnet",
            chainsymbol         : "FTM",
            rpcUrls             : "https://rpc.testnet.fantom.network/",
            blockExplorerUrls   : "https://testnet.ftmscan.com/",
            networkVersion      : 4002,
            chainid             : 4002,
            networkdecimal      : 18,
            bridgecontract      : "0x20566d84d979841849478E3d17FC81445152B84b",
            tokencontract       : "0x20566d84d979841849478E3d17FC81445152B84b",
            image               : "fantom.png",
            payable             : 3,
            passchainid         : 10112
            
        },
        

   ];
}

export default key;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         